import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ReactComponent as Logo } from '../assets/86 ICE La Migra_Secondary Identity Full Color-13.svg';

const Footer = () => {
  const { translate } = useLanguage();

  return (
    <footer>
      <div className="container">
        <Logo title="86 ICE!" />
        <p>{translate('COPYRIGHT_TEXT')}</p>
      </div>
    </footer>
  );
};

export default Footer;